import React, { Component } from 'react';
import { ResetPassword } from '$components/auth';
import { resetPassword } from '$actions/accounts';
import { changeTitle } from '$actions/root';
import { formSelector } from '$selectors';
import { connect } from 'react-redux';
import {Translate} from "$common";

@connect(state => ({
  form: formSelector(state, 'resetPassword')
}), { resetPassword, changeTitle })
export default class ResetPasswordRoute extends Component {
  componentWillMount() {
    this.props.changeTitle(Translate.get('reset_my_password'))
  }

  changePassword(params) {
    const token = this.props.location.query['reset-password-token'];
    this.props.resetPassword({ ...params, token });
  }

  render() {
    const { form } = this.props;

    return (
      <ResetPassword
        errors={form.errors}
        onSubmit={::this.changePassword}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/auth/reset-password.js